import { Badge } from "@/components/ui/badge";
import { DefaultButton } from "@/components/ui/button";
import { useRegeneratePolling } from "./hooks/useRegeneratePolling";
import { useParams } from "react-router-dom";
import { getBadgeVariant } from "@/utils/helper/getBadgeVariant";
import { useGenerateABDFDTs } from "@/api/generate-abd-fdt";
import { useOPMFDTs } from "@/api/opm-fdt";
import { useState } from "react";

export default function RegenerateSection() {
  const { id } = useParams<{ id: string }>();
  const { startPolling, currentStatus, isLoading } = useRegeneratePolling({
    id,
  });

  // 1 RFS has at most 1 OPM FDT record; sometimes generation succeeds but the
  // BE fails to create it, leaving abdFdts populated but opmFdts empty. Keep
  // the button visible in that case so the user can regenerate.
  const { data: abdFdts, isFetching: isAbdFdtsFetching } = useGenerateABDFDTs({
    rfsId: id,
  });
  const { data: opmFdts, isFetching: isOpmFdtsFetching } = useOPMFDTs({
    rfsId: id ?? "",
  });
  const isOpmFdtMissing =
    (abdFdts?.length ?? 0) > 0 &&
    !isAbdFdtsFetching &&
    !isOpmFdtsFetching &&
    (opmFdts?.length ?? 0) === 0;

  // SUCCESS badge disembunyikan saat halaman baru dibuka (OPM FDT hilang),
  // tapi ditampilkan lagi setelah user menekan Regenerate.
  const [hasRegenerated, setHasRegenerated] = useState(false);

  const handleRegenerateClick = () => {
    if (id) {
      setHasRegenerated(true);
      startPolling(); // Cukup panggil fungsi dari hook
    }
  };

  const getVariant = () => {
    if (isLoading) return getBadgeVariant("IN PROGRESS");

    if (currentStatus) {
      return getBadgeVariant(currentStatus);
    }
  };

  if (currentStatus === "SUCCESS" && !isOpmFdtMissing) {
    return null;
  }

  return (
    <div className="flex gap-x-1">
      {(isLoading ||
        (currentStatus && (currentStatus !== "SUCCESS" || hasRegenerated))) && (
        <Badge variant={getVariant()}>
          {isLoading ? "IN PROGRESS" : currentStatus}
        </Badge>
      )}
      <DefaultButton
        mood="axiata-blue"
        loading={isLoading}
        onClick={handleRegenerateClick}
        disabled={isLoading || currentStatus === "IN_PROGRESS"}
      >
        {isLoading ? "Regenerating..." : "Regenerate Data"}
      </DefaultButton>
    </div>
  );
}
